module.exports = __webpack_public_path__ + "img/22.602071e7.jpg";